<template>
  <div
    class="tw:w-full tw:bg-blue-500 tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-integration-bar-height"
  >
    <span class="tw:text-white tw:body-1 tw:line-clamp-2">
      {{ trans._notifications.integrationIncomplete }}
    </span>

    <EdroneButton size="medium" @click="goToIntegration">
      {{ trans._notifications.completeIntegration }}
    </EdroneButton>
  </div>
</template>

<script lang="ts" setup>
import EdroneButton from "edrone-components/EdroneButton.vue";
import { useRouter } from "vue-router";
import { INTEGRATION_INCOMPLETE_BAR_HEIGHT } from "vue-app/types/enums";

const router = useRouter();

const goToIntegration = () => {
  router.push("/app/integrations");
};

const integrationBarHeightCss = `${INTEGRATION_INCOMPLETE_BAR_HEIGHT}rem`;
</script>

<style scoped>
.max-integration-bar-height {
  max-height: v-bind(integrationBarHeightCss);
}
</style>
